import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DemoComponent } from './demo/demo.component';
import { JobExperienceComponent } from './job-experience/job-experience.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'demo', component: DemoComponent },
  { path: 'experience', component: JobExperienceComponent }
  ,{ path: 'cookie-policy', component: CookiePolicyComponent }
  ,{ path: 'legal', component: LegalNoticeComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
